import { sortBy, uniqBy } from 'lodash'

const initialState = {
  loaded: [],
  progress: 100,
  step: 'DONE'
}

const capacity = (state = initialState, { type, capacity = [] }) => {
  switch (type) {
    case 'CLEAR_CAPACITY':
      return { ...state, loaded: [] }

    case 'ADD_CAPACITY': {
      // Sort by createdDate and keep unique by date if there are duplicates
      let newCapacity = uniqBy(sortBy([...state.loaded, ...capacity], ['date', 'createdDate']), 'date').filter(({ inProgress }) => !inProgress)

      return { ...state, loaded: newCapacity }
    }

    default:
      return state
  }
}

export default capacity
